import CustomAlert from '../CustomAlert';
import { AlertMessage } from '../models';

export default function AccountCustomAlert({
  message,
  onAlertClose = null,
}: {
  message: AlertMessage;
  onAlertClose?: (alert: AlertMessage) => void;
}) {
  return (
    <CustomAlert message={message} onAlertClose={onAlertClose}>
      <b className="text-nowrap me-2">Important announcement!</b>
      {message.message}
    </CustomAlert>
  );
}
